import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { putDiameter } from '../Api'

export default generateApiAction({
  baseType: Types.DIAMETERS.PUT,
  api: putDiameter,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/diameters/PutAction.js